import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex space-x-1" }
const _hoisted_2 = { class: "w-36 text-left" }
const _hoisted_3 = { class: "py-1" }

import DefaultIconButton from '@/components/Buttons/DefaultIconButton.vue';
import { SortBy, SortDirection } from '@/models/EntitySort';
import store from '@/store';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/vue/outline';
import { ChevronDownIcon } from '@heroicons/vue/solid';
import { computed, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const sortDirection = computed(() => store.getters['entitySort/sortDirection'] as SortDirection);

const setSortBy = async (sortBy: SortBy) => {
  await store.dispatch('entitySort/setSortBy', sortBy);
};

const setSortDirection = async (sortDirection: SortDirection) => {
  await store.dispatch('entitySort/setSortDirection', sortDirection);
};

const sortByText = computed(() => store.getters['entitySort/sortByText'] as string);

onUnmounted(() => {
  // reset sorting
  store.dispatch('entitySort/resetSortBy');
  store.dispatch('entitySort/resetSortDirection');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Menu), {
      as: "div",
      class: "relative text-left h-10"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(MenuButton), { class: "inline-flex rounded border border-gray-300 px-4 py-2 text-sm font-medium hover:bg-gray-50 focus:outline-none active:outline-none h-10" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, "Sort by " + _toDisplayString(_unref(sortByText)), 1),
              _createVNode(_unref(ChevronDownIcon), {
                class: "-mr-1 ml-2 h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MenuItems), { class: "origin-top-left absolute left-0 mt-2 w-56 rounded shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("button", {
                        class: _normalizeClass([
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block w-full text-left px-4 py-2 text-sm',
                ]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (setSortBy(_unref(SortBy).RELEVANCE)))
                      }, " Sort by relevance ", 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("button", {
                        class: _normalizeClass([
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block w-full text-left px-4 py-2 text-sm',
                ]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (setSortBy(_unref(SortBy).RECENCY)))
                      }, " Sort by recency ", 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("button", {
                        class: _normalizeClass([
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block w-full text-left px-4 py-2 text-sm',
                ]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (setSortBy(_unref(SortBy).CITATION_COUNT)))
                      }, " Sort by citation count ", 2)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MenuItem), null, {
                    default: _withCtx(({ active }) => [
                      _createElementVNode("button", {
                        class: _normalizeClass([
                  active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                  'block w-full text-left px-4 py-2 text-sm',
                ]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (setSortBy(_unref(SortBy).ALPHABETIC)))
                      }, " Sort by title ", 2)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_unref(sortDirection) === _unref(SortDirection).DESC)
        ? (_openBlock(), _createBlock(DefaultIconButton, {
            key: 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (setSortDirection(_unref(SortDirection).ASC)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowDownIcon))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(sortDirection) === _unref(SortDirection).ASC)
        ? (_openBlock(), _createBlock(DefaultIconButton, {
            key: 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (setSortDirection(_unref(SortDirection).DESC)))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowUpIcon))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})